// JavaScript Error Diagnostics for Shopify Theme
// This script helps identify and prevent null reference errors

(function() {
  'use strict';

  // Global error handler to catch and log JavaScript errors
  window.addEventListener('error', function(event) {
    const error = event.error;
    const message = event.message;
    const filename = event.filename;
    const lineno = event.lineno;
    const colno = event.colno;

    // Log error details for debugging
    console.warn('JavaScript Error Caught:', {
      message: message,
      filename: filename,
      line: lineno,
      column: colno,
      stack: error ? error.stack : 'No stack trace available'
    });

    // Don't prevent default error handling
  });

  // Global unhandled promise rejection handler
  window.addEventListener('unhandledrejection', function(event) {
    console.warn('Unhandled Promise Rejection:', event.reason);

    // Don't prevent default handling
  });

  // Utility function to safely check if an element exists and has required methods
  window.safeElementOperation = function(element, operation, fallback = null) {
    try {
      if (!element || typeof element !== 'object') {
        console.warn('safeElementOperation: Invalid element provided');
        return fallback;
      }

      if (typeof operation === 'function') {
        return operation(element);
      }

      return element;
    } catch (error) {
      console.warn('safeElementOperation: Error during operation:', error);
      return fallback;
    }
  };

  // Utility function to safely query DOM elements
  window.safeQuerySelector = function(selector, context = document) {
    try {
      if (!context || !context.querySelector) {
        console.warn('safeQuerySelector: Invalid context provided');
        return null;
      }
      return context.querySelector(selector);
    } catch (error) {
      console.warn('safeQuerySelector: Error querying selector:', selector, error);
      return null;
    }
  };

  // Utility function to safely query multiple DOM elements
  window.safeQuerySelectorAll = function(selector, context = document) {
    try {
      if (!context || !context.querySelectorAll) {
        console.warn('safeQuerySelectorAll: Invalid context provided');
        return [];
      }
      return Array.from(context.querySelectorAll(selector));
    } catch (error) {
      console.warn('safeQuerySelectorAll: Error querying selector:', selector, error);
      return [];
    }
  };

  console.log('JavaScript Error Diagnostics loaded successfully');

})();